'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2018 Adobe Systems Incorporated. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


require('isomorphic-fetch');

var _constants = require('./constants');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A Client class used for communicating with the People Graph Service.
 * https://pgc-stage.adobe.io/docs/?api_key=<yourApiKey>
 */
var Client = function () {
  /**
   * Constructor for Client.
   * @access private
   */
  function Client() {
    _classCallCheck(this, Client);

    this._environment = 'stage';
    this._apiKey = null;
  }

  /**
   * Configure the People Graph access layer.
   * @param {object} settings -
   *    settings.environment: The environment (stage, prod).
   *    settings.apiKey: The api key
   * @example <caption>Configuring the Client</caption>
   * Client.instance.configure({
   *   environment: 'stage',
   *   apiKey: '<apiKey>',
   * });
   * @returns {undefined}
   */


  _createClass(Client, [{
    key: 'configure',
    value: function configure(settings) {
      var acceptHeaderVersion = settings.acceptHeaderVersion,
          apiKey = settings.apiKey,
          environment = settings.environment,
          token = settings.token;


      if (environment) {
        this.setEnvironment(environment);
        this._endpoint = (0, _constants.getConfigValue)(this._environment, 'PGS_ENDPOINT');
      }

      if (apiKey) {
        this._apiKey = apiKey;
      }

      if (token) {
        this._token = token;
      }

      this._acceptHeaderVersion = 'application/vnd.adobe.people-graph.' + (acceptHeaderVersion && acceptHeaderVersion.toLowerCase() || 'v1') + '+json';

      // If we have all the necessary data, run the configuration methods
      if (this._environment && this._endpoint && this._apiKey) {
        return this.discover();
      } else {
        return Promise.resolve([]);
      }
    }

    /**
     * Set the environment.
     * @param {string} environment - The new environment
     * @example <caption>Setting the environment</caption>
     * Client.instance.environment = 'stage';
     */

  }, {
    key: 'setEnvironment',
    value: function setEnvironment(environment) {
      var acceptedEnvironments = ['stage', 'prod'];
      var acceptedEnvironmentsString = '';
      // Create the string based on acceptedEnvironments.
      acceptedEnvironments.forEach(function (acceptedEnvironment, index) {
        var endString = index + 1 === acceptedEnvironments.length ? '' : ', ';
        acceptedEnvironmentsString += acceptedEnvironment + endString;
      });
      // If the value specified is not accepted, throw an error.
      if (acceptedEnvironments.indexOf(environment) === -1) {
        throw new Error('Setting the environment to ' + environment + ' is not accepted. Acceptable values are ' + acceptedEnvironmentsString);
      }

      // Set the environment variable
      this._environment = environment;
      this._endpoint = (0, _constants.getConfigValue)(this._environment, 'PGS_ENDPOINT');
    }

    /**
     * Method to call to discover the api endpoints from people graph service.
     * Only the discover endpoint is static, the other endpoints such as suggestion and accept
     * are dynamic. They could look static but we are not supposed to construct them as they
     * may change.
     * @return {undefined}
     */

  }, {
    key: 'discover',
    value: function discover() {
      var _this = this;

      return this.fetch(this._endpoint, 'GET').then(function (response) {
        if (response && response._links) {
          var links = response._links;
          _this._suggestionApiHref = links.suggest && links.suggest.href ? links.suggest.href : undefined;
          _this._acceptApiHref = links.accept && links.accept.href ? links.accept.href : undefined;
          _this._acceptMaxItems = links.accept && links.accept.limits && links.accept.limits.max_items ? links.accept.limits.max_items : undefined;
        } else {
          throw new Error('Links not found from discovery entry point');
        }
      }).catch(function (error) {
        console.log(error);
      });
    }

    /**
     * Get suggestions query with tags or type but it cannot have both. relationship = 'INVITE' cannot have tags
     * @param {String} text - The search term.
     * @param {String} type - PERSON, GROUP  Defaults to ["PERSON", "GROUP"].
     * @param {Array} tags - Tags used to filter the PGC response
     * @returns {Object}
     */

  }, {
    key: 'getQuery',
    value: function getQuery(text, type) {
      var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var query = {
        type: type === 'PERSON' || type === 'GROUP' ? [type] : ['PERSON', 'GROUP'],
        value: text
      };

      if (tags.length) {
        query.tags = tags;
      }

      return query;
    }

    /**
     * Get suggestions using input string
     * @param {Object} request - request object with properties that will be destructed
     * @param {String} request.relationship - The kind of relationship about to be established. Defaults to 'INVITE'.
     * @param {String} request.searchText - The search term.
     * @param {Object} request.tags - Array of tags to be included
     * @returns {Promise}
     */

  }, {
    key: 'getSuggestions',
    value: function getSuggestions() {
      var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var peopleType = request.peopleType,
          _request$relationship = request.relationship,
          relationship = _request$relationship === undefined ? 'INVITE' : _request$relationship,
          resourceType = request.resourceType,
          resourceUrl = request.resourceUrl,
          resourceUrn = request.resourceUrn,
          _request$searchText = request.searchText,
          searchText = _request$searchText === undefined ? '' : _request$searchText,
          tags = request.tags;


      if (this._suggestionApiHref === undefined) {
        return Promise.reject('People Graph SDK has not been properly configured yet.  Missing suggestions api endpoint.');
      } else if (!resourceType) {
        return Promise.reject('Missing resourceType. resourceType is required to get PGC suggestions.');
      } else {
        // If input is empty or length is too large, return empty results
        if (searchText.length > (0, _constants.getConfigValue)(this._environment, 'MAX_LENGTH')) {
          return Promise.resolve([]);
        }

        var body = {
          resourceType: resourceType,
          resourceUrn: resourceUrn,
          resourceUrl: resourceUrl,
          relationship: relationship,
          query: this.getQuery(searchText, peopleType, tags)
        };

        return this.fetch(this._suggestionApiHref, 'POST', body, { 'x-ccx-workflow': true }).then(function (response) {
          if (response && response._embedded && response._embedded.suggestions) {
            return response._embedded.suggestions;
          } else {
            throw new Error('Response did not contain suggestions.');
          }
        });
      }
    }

    /**
     * Accept suggestions
     * @param {Array} tokens - array of tokens
     * @returns {Promise}
     */

  }, {
    key: 'acceptTokens',
    value: function acceptTokens(tokens) {
      if (this._acceptApiHref === undefined) {
        return Promise.reject('People Graph SDK has not been properly configured yet. Missing accept api endpoint.');
      } else if (tokens.length > this._acceptMaxItems) {
        return Promise.reject('Attempting to accept more tokens than the service max limit.');
      } else {
        var body = {
          tokens: tokens
        };
        return this.fetch(this._acceptApiHref, 'POST', body).then(function (response) {
          if (response && response._embedded) {
            return response._embedded;
          } else {
            throw new Error('Response did not contain addresses');
          }
        });
      }
    }

    /**
     * @access private
     * @param {String} url The API endpoint.
     * @param {String} method GET, POST, PUT, UPDATE, or DELETE.
     * @param {Object} body The body object.
     * @param {Object} headers Any additional headers to apply to the fetch call
     */

  }, {
    key: 'fetch',
    value: function (_fetch) {
      function fetch(_x, _x2, _x3, _x4) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (url, method, body, headers) {
      // Setup the method (or default)
      var _method = method || 'GET';
      var token = this._token;

      // Check if we have a token for non-GET calls.
      if (_method !== 'GET' && !token) {
        return Promise.reject('Authorization not configured. Please set the bearer token before calling this method.');
      }

      // Setup the default headers and add any additional headers
      var _headers = Object.assign({
        'Content-Type': 'application/json',
        'X-API-Key': this._apiKey,
        Authorization: token ? token.indexOf('Bearer ') > -1 ? token : 'Bearer ' + token : undefined,
        Accept: this._acceptHeaderVersion
      }, headers);

      return fetch(url, {
        method: _method,
        headers: _headers,
        body: body ? JSON.stringify(body) : undefined
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        var error = new Error(response.statusText);
        error.response = response;

        throw error;
      });
    })
  }]);

  return Client;
}();

/**
 * Exports the Client class.
 */


exports.default = Client;
module.exports = exports['default'];